import Form from "@/components/Form";
import './style.css'

export default class RegisterYourInterestForm {
    static selector = '.register-interest-form'

    constructor(block) {
        this.block = block;

        this.formElement = this.block.querySelector(".form");

        this.form = new Form(this.formElement, {
            onSubmitSucceeded: this.handleSubmitSucceeded,
            submitLoadingLabel: 'Sending...',
            submitSuccessLabel: 'Sent',
            resetAfterSubmit: false,
            gainControlOnSubmitSucceeded: false,
        });

        this.otherCheckbox = document.getElementById('register-interest-checkbox-client-type-7');

    }

    handleSubmitSucceeded = (response) => {
        console.log('Success!', response);
    };

    onReady = () => {
        if(this.otherCheckbox) {
            this.otherCheckbox.addEventListener('change', this.onOtherChange);
            this.onOtherChange();
        }
    }

    onDestroy = () => {
        if(this.otherCheckbox) {
            this.otherCheckbox.removeEventListener('change', this.onOtherChange);
        }
    }

    onOtherChange = () => {      
        const parent = this.otherCheckbox.closest('.form__group');

        if(this.otherCheckbox.checked) {
            parent.classList.add('show-other');
        } else {
            parent.classList.remove('show-other');
        }
    }
}
